import { compact } from 'lodash/fp'
import _ from 'lodash'
import BIMESSAGES from 'core/data-model/constants/bi-messages'
import VALUES from 'core/data-model/constants/values'
import { LIFE_PROTECT_PLUS_GROUP_CODES } from 'core/data-model/constants/product-groups'

import {
  LegalConditionDisclaimerMarketConduct,
  LegalConditionDisclaimerMarketConductNoAddtionalContract,
  LegalConditionDisclaimerMarketConductEasyProtect6,
  LegalConditionDisclaimerMarketConductLifeProtectPlus,
} from 'quick-quote/v2/components/disclaimers'
import ProfileSnapshot from 'quick-quote/product-common/benefit-illustration/components/profile-summary/profile-snapshot'
import ProductBenefits from 'quick-quote/product-whole-life/benefit-illustration/components/product-benefits/product-benefits'
import RiderBenefits from 'quick-quote/product-common/benefit-illustration/components/rider-benefits'
import TaxConsentDeductionBenefit from 'quick-quote/product-common/benefit-illustration/components/tax-consent-deduction-benefit'

import PolicyValueTableLifeReady from 'quick-quote/v2/components/benefit-illustration/policy-values/layout-with-cash-drop/policy-value-table-life-ready'

import { getProfileSnapshot } from 'quick-quote/product-common/benefit-illustration/components/profile-summary/selectors'
import { getProductBenefits } from 'quick-quote/product-whole-life/benefit-illustration/components/product-benefits/selectors'
import { getSelectedRiders } from 'quick-quote/product-common/coverage-plan/selectors'
import { getPolicyValueTableBenefits } from 'quick-quote/v2/components/benefit-illustration/policy-values/layout-with-cash-drop/selectors'
import { getTaxDeduction } from 'quick-quote/product-whole-life/benefit-illustration/selectors'
import { getLegalConditionDisclaimer } from 'quick-quote/v2/components/disclaimers/selectors'
import { getSelectedDisplayProduct, getSelectedDisplayProductCode } from 'quick-quote/product-selection/selectors'

const _summaryHeaderWithCode = ({ displayProduct }) => {
  let name = _.get(displayProduct, 'displayName', '')
  if (
    Object.values(VALUES.ROKE_RAI_SO_SHIELD_CODE)
      .concat(Object.values(VALUES.LIFEREADY_SIO_CODE))
      .includes(displayProduct.code)
  )
    name = BIMESSAGES.LIFE_READY_PACKAGE_NAME

  const basicPlanCode = _.get(displayProduct, 'basicPlanCode', '')
  return `${name} (${basicPlanCode})`
}

const _summaryHeader = ({ displayProduct }) => {
  if (LIFE_PROTECT_PLUS_GROUP_CODES.includes(displayProduct.code)) {
    return displayProduct.nameThai
  }
  return VALUES.LIFEREADY_CAMPAIGN_CODE.concat(Object.values(VALUES.LIFEREADY_SIO_CODE)).includes(displayProduct.code)
    ? BIMESSAGES.LIFE_READY_PACKAGE_NAME
    : VALUES.LIFETREASURE_GROUP_CODE.includes(displayProduct.code)
    ? BIMESSAGES.LIFE_TREASURE_NAME_THAI
    : displayProduct.displayName
}

export const getSections = (state) => {
  const riders = getSelectedRiders(state)
  const productCode = getSelectedDisplayProductCode(state)
  return compact([
    {
      component: ProfileSnapshot,
      props: {
        ...getProfileSnapshot(state),
        profileSummaryHeader: _summaryHeaderWithCode,
        summaryTableHeader: _summaryHeader,
      },
    },
    {
      component: ProductBenefits,
      props: {
        ...getProductBenefits(state),
      },
    },
    riders.length > 0 && {
      component: RiderBenefits,
    },
    {
      component: PolicyValueTableLifeReady,
      props: {
        ...getPolicyValueTableBenefits(state),
      },
    },
    {
      component: TaxConsentDeductionBenefit,
      props: {
        taxDeduction: getTaxDeduction(state),
        productCode,
      },
    },
    {
      component: getLegalConditionDisclaimerMarketConduct(productCode),
      props: {
        ...getLegalConditionDisclaimer(state),
        productCode,
      },
    },
  ])
}

const getLegalConditionDisclaimerMarketConduct = (productCode) => {
  if (Object.values(VALUES.LIFEREADY_SIO_CODE).includes(productCode)) {
    return LegalConditionDisclaimerMarketConductNoAddtionalContract
  } else if (productCode === 'W99F06A') {
    return LegalConditionDisclaimerMarketConductEasyProtect6
  } else if (LIFE_PROTECT_PLUS_GROUP_CODES.includes(productCode)) {
    return LegalConditionDisclaimerMarketConductLifeProtectPlus
  } else {
    return LegalConditionDisclaimerMarketConduct
  }
}

export const getMenus = (state) => {
  const selectedDisplayProduct = getSelectedDisplayProduct(state)
  return compact([
    {
      text: selectedDisplayProduct?.riders?.length
        ? BIMESSAGES.SUMMARY_OF_MAIN_AND_ADDITIONAL_CONTRACTS
        : BIMESSAGES.SUMMARY_OF_MAIN_CONTRACTS,
      id: 'profile-summary',
      isSub: false,
    },
    {
      text: 'รายละเอียดของสัญญาหลัก',
      id: 'product-benefits',
      isSub: false,
    },
    {
      text: BIMESSAGES.POLICY_VALUE_TABLE,
      id: 'policy-value',
      isSub: false,
    },
    {
      text: BIMESSAGES.LEGAL_DISCLAIMER,
      id: 'legal-disclaimer-market-conduct',
      isSub: false,
    },
  ])
}
